export default "__VITE_PUBLIC_ASSET__bd13f81c__"